import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';

export class DatadogResolver {
  static resolveConfig(environment: string, version: string | undefined): RumInitConfiguration {
    const useSbx =
      environment === 'dev' ||
      (process.env['NODE_ENV'] === 'development' && process.env['REACT_APP_BUILD_NUMBER'] === 'local');
    const env = useSbx ? 'dev' : environment;

    const applicationId = useSbx ? '7dc468fe-da6b-43f4-85f0-a64c6c189c29' : 'ddd64f34-0d56-4ba2-adc1-9f5c3f0ec242';
    const clientToken = useSbx ? 'pub2d38d3de86a0afdce95450394bb2d754' : 'pub18401440fe79f391e12cfd8b736c3470';

    return {
      applicationId: applicationId,
      clientToken: clientToken,
      site: 'datadoghq.com',
      service: 'digital-claims-v2-ui',
      env: env,
      version: version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackSessionAcrossSubdomains: true,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
      beforeSend: (event, context) => {
        // Ensure all events have consistent global context properties
        const globalContext = datadogRum.getGlobalContext();

        // Add critical context properties to all events if they exist
        if (globalContext.policyNumbers) {
          event.context = { ...event.context, policyNumbers: globalContext.policyNumbers };
        }
        if (globalContext.urlId) {
          event.context = { ...event.context, urlId: globalContext.urlId };
        }
        if (globalContext['afe-session-id']) {
          event.context = { ...event.context, 'afe-session-id': globalContext['afe-session-id'] };
        }
        if (globalContext.sessionStatus) {
          event.context = { ...event.context, sessionStatus: globalContext.sessionStatus };
        }

        return true;
      },
    };
  }
}
